import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  MainContainer,
  ButtonGroup,
  BackButton,
  SubmitButton,
  StyledForm,
  StyledFormElementsWrapper,
} from "../../ManagementTools/component/styles";
import { Formik } from "formik";
import { CustomFileUpload } from "../../../common/FormInputs";
import {
  Modal,
  FormLabel,
  makeStyles,
  Radio,
  RadioGroup,
  Grid,
  FormControlLabel,
} from "@material-ui/core";
import { getErrorMessage, getFileName } from "../../../../helpers/functions";
import { Heading, HeadingContainer } from "../../../../styles/component/style";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import AWSService from "../../../../services/AWSService";
import NoticeService from "../../../../services/NoticeService";
import { reGenerateValidationSchema } from "../../../../helpers/validationSchema";
import Axios from "axios";
import ValidationErrors from "../../NoticeGeneration/component/ValidationError";
import FormField from "../../../common/FormField/FormField";

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#293461",
  },
}));

const GenerateNotice = ({ paperModal, setPaperModal }) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [modal, setModal] = useState({ state: false });
  const classes = useStyles();
  const [letterHeadOption, setLetterHeadOption] = useState({});
  const [letterHeadNames, setLetterHeadNames] = useState([]);

  async function s3Upload(file, field, setFieldValue, setFieldError) {
    if (file) {
      try {
        setLoader({ state: true, message: `Uploading file ${file.name} ...` });
        const payload = {
          key: file.name,
        };
        const s3Response = await AWSService.getS3URL(payload);
        if (s3Response.url) {
          const res = await AWSService.uploadToS3(s3Response.url, file);
          setFieldValue(field, res);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        setFieldError(field, message);
      } finally {
        setLoader({ state: false });
      }
    }
  }

  useEffect(() => {
    async function getNoticeTemplates(partyId) {
      try {
        setLoader({ state: true, message: "fetching notice details..." });
        const response = await NoticeService.getNoticeTemplates(partyId);
        if (response[0]) {
          setLetterHeadNames(response[0]?.letterHeadArr || []);
          setLetterHeadOption(response[0]?.letterHeadOption || {});
        }
      } catch (err) {
        enqueueSnackbar(err?.message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }

    if (paperModal?.metaData?.partyId) {
      getNoticeTemplates(paperModal?.metaData?.partyId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperModal?.metaData?.partyId]);

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "Regenerate notice..." });
      const source =
        values?.letterHeadName &&
        letterHeadOption[values?.letterHeadName]?.length &&
        letterHeadOption[values?.letterHeadName][0];
      let letterHeadPayload;
      if (source) {
        if (source.letterHeadType === "image") {
          letterHeadPayload = {
            id: source.id,
            headerImage: source.headerImage || "",
            footerImage: source.footerImage || "",
            letterHeadType: "image",
          };
        } else if (source.letterHeadType === "text") {
          letterHeadPayload = {
            id: source.id,
            letterHeadType: "text",
            headerFooterText: {
              headerText: source.headerFooterText?.headerText || [],
              footerText: source.headerFooterText?.footerText || [],
            },
            headerAlignment: values?.headerAlignment || "left",
            footerAlignment: values?.footerAlignment || "left",
          };
        }
      } else {
        letterHeadPayload = { headerImage: "", footerImage: "" };
      }
      let payload = {
        ...paperModal?.metaData,
        excelFile: values?.excelFile,
        loanType: values?.loanType,
        loanStatus: values?.loanStatus,
        letterHeadName: values?.letterHeadName,
        letterHeadImages: letterHeadPayload,
      };
      const res = await Axios.post(
        "https://mod.justact.co.in/check-keyerror",
        {
          noticeTemplate: paperModal?.metaData?.noticeTemplate,
          excelFile: values?.excelFile,
        },
      );
      if (res.data.message) {
        const response = await NoticeService.bulkNoticeGenerate(payload);
        if (response?.message) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
        }
        setPaperModal({ state: false });
      } else {
        setModal({ state: true, metaData: res.data });
      }
    } catch (err) {
      const error = getErrorMessage(err);
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const input_alignments = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
  ];

  return (
    <React.Fragment>
      {modal?.state ? (
        <ValidationErrors {...{ modal, setModal }} />
      ) : (
        <Modal
          open={paperModal?.state}
          onClose={() => setPaperModal({ state: false })}
          disableRestoreFocus
        >
          <DrawerContainer>
            <HeadingContainer>
              <Heading>{"Regenerate Notice"}</Heading>
              <CloseModal
                onClick={() => setPaperModal({ state: false })}
                src={require("../../../../assets/images/closeModal.svg")}
              />
            </HeadingContainer>
            <MainContainer style={{ marginTop: 20 }}>
              <Formik
                initialValues={{
                  excelFile: "",
                  fileUpload: "",
                  loanType: "",
                  loanStatus: "",
                  letterHeadName: "",
                  headerAlignment: "left",
                  footerAlignment: "left",
                  typeOfLetterHead: "image",
                }}
                validationSchema={reGenerateValidationSchema}
                enableReinitialize
                onSubmit={onFormSubmit}
                validateOnBlur
                validateOnChange
              >
                {({
                  values,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  setFieldError,
                  resetForm,
                }) => {
                  const menuHeaderFooter = [
                    { label: "None", value: "" },
                    ...letterHeadNames
                      .filter(
                        (name) =>
                          letterHeadOption[name]?.length &&
                          letterHeadOption[name][0]?.letterHeadType ===
                            values.typeOfLetterHead,
                      )
                      .map((name) => ({
                        label: name,
                        value: name,
                      })),
                  ];

                  return (
                    <StyledForm>
                      <StyledFormElementsWrapper
                        style={{ marginBottom: 8, marginTop: 15 }}
                      >
                        {[
                          {
                            name: "excelFile",
                            label: "Upload Xlsx",
                            type: "upload",
                            required: true,
                            fileName: "excel",
                            accept: ".xlsx",
                            types: [
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              "application/vnd.ms-excel",
                              "text/csv",
                            ],
                          },
                        ].map((upload, index) => (
                          <div style={{ marginTop: 10 }}>
                            <FormLabel
                              style={{
                                fontFamily: "openSans-SemiBold, sans-serif",
                                fontSize: 12,
                                color: "#949ab0",
                              }}
                            >
                              {upload.label}{" "}
                              <span className="required-star"> *</span>
                            </FormLabel>
                            <CustomFileUpload
                              error={
                                touched[upload.name] && errors[upload.name]
                              }
                              setFile={(file) =>
                                s3Upload(
                                  file,
                                  "excelFile",
                                  setFieldValue,
                                  setFieldError,
                                )
                              }
                              // setFile={(file) => setFieldValue("fileUpload", file)}
                              style={{
                                width: "100%",
                              }}
                              accept={upload.accept}
                              file={{
                                name: getFileName(values[upload.name]),
                              }}
                            />
                          </div>
                        ))}
                        {[
                          {
                            type: "select",
                            name: "loanType",
                            label: "Loan Type",
                            required: false,
                            items: [
                              { label: "Vehicle Loan", value: "vehicleLoan" },
                              { label: "Business Loan", value: "businessLoan" },
                              { label: "Personal Loan", value: "personalLoan" },
                            ],
                          },
                          {
                            type: "select",
                            name: "loanStatus",
                            label: "Loan Status",
                            required: false,
                            items: [
                              { label: "Matured", value: "matured" },
                              { label: "Short Fall", value: "shortFall" },
                              { label: "Running", value: "running" },
                            ],
                          },
                        ].map((input, index) => {
                          return (
                            <FormField
                              key={index}
                              menuItems={input.items}
                              {...{
                                touched,
                                errors,
                                input,
                                values,
                                handleChange,
                                handleBlur,
                                setFieldValue,
                              }}
                            />
                          );
                        })}

                        <Grid
                          className={classes.radioRoot}
                          item
                          xs={12}
                          spacing={2}
                          style={{ marginBottom: "5px", marginTop: 10 }}
                        >
                          <RadioGroup
                            style={{
                              flexDirection: "row",
                              marginLeft: "10px",
                            }}
                            name={"typeOfLetterHead"}
                            value={values.typeOfLetterHead}
                            onChange={(e) => {
                              setFieldValue("typeOfLetterHead", e.target.value);
                              setFieldValue("letterHeadName", "");
                            }}
                          >
                            {[
                              {
                                label: "Image",
                                name: "image",
                                value: "image",
                              },
                              {
                                label: "Text",
                                name: "text",
                                value: "text",
                              },
                            ].map((radio, key) => (
                              <FormControlLabel
                                {...{ key }}
                                classes={{ label: classes.formLabel }}
                                value={radio.value}
                                control={
                                  <Radio
                                    size="medium"
                                    style={{ color: "#00838c" }}
                                  />
                                }
                                label={radio.label}
                              />
                            ))}
                          </RadioGroup>
                        </Grid>

                        {[
                          {
                            type: "select",
                            name: "letterHeadName",
                            label: "Letter Head Name",
                            required: false,
                            items: menuHeaderFooter,
                          },
                        ].map((input, index) => {
                          return (
                            <FormField
                              key={index}
                              menuItems={input.items}
                              {...{
                                touched,
                                errors,
                                input,
                                values,
                                handleChange,
                                handleBlur,
                                setFieldValue,
                              }}
                            />
                          );
                        })}
                        {values?.typeOfLetterHead === "text"
                          ? [
                              {
                                type: "select",
                                name: "headerAlignment",
                                label: "Header Alignment",
                                required: false,
                                items: input_alignments,
                              },
                              {
                                type: "select",
                                name: "footerAlignment",
                                label: "Footer Alignment",
                                required: false,
                                items: input_alignments,
                              },
                            ].map((input, index) => {
                              return (
                                <FormField
                                  key={index}
                                  menuItems={input.items}
                                  {...{
                                    touched,
                                    errors,
                                    input,
                                    values,
                                    handleChange,
                                    handleBlur,
                                    setFieldValue,
                                  }}
                                />
                              );
                            })
                          : null}
                      </StyledFormElementsWrapper>
                      <ButtonGroup>
                        <BackButton
                          onClick={() => setPaperModal({ state: false })}
                        >
                          Close
                        </BackButton>
                        <SubmitButton onClick={handleSubmit}>
                          Submit
                        </SubmitButton>
                      </ButtonGroup>
                    </StyledForm>
                  );
                }}
              </Formik>
            </MainContainer>
          </DrawerContainer>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default GenerateNotice;

const DrawerContainer = styled.div`
  max-width: 516px;
  width: 100%;
  background-color: white;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  padding: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  border: 1px solid #a5bfcc;
`;

const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 30px;
`;
